import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import React from "react";
import { instance } from "Actions/AxiosInstance";
import { ResponsiveLineCanvas } from "@nivo/line";
import DynamicForm from "Component/DynamicForm";
import { ResponsiveBarCanvas } from "@nivo/bar";
import { Doughnut } from "react-chartjs-2";
import { ResponsiveCalendarCanvas } from "@nivo/calendar";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { multiselectinputconverter } from "Component/DynamicForm/Fields/MultiSelect";
import Clock from "Assets/Icons/Clock-time/clock-time-16px.svg";
import employee from "Assets/Icons/Employees/employees-16px.svg";
import Search from "Assets/Icons/Search/search-16px.svg";
import LabelIcon from "Component/Labels/LabelIcon";
import ShareIdea from "./ShareIdea";
import {
  filterTypes,
  subfilterTypes,
  attendanceStateTypes,
  requestCountTypes,
} from "./constants";

class Employeetracking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ldfiltertypeid: 1,
      ldsubfiltertypeid: 2,
      leavedistribution: [],
      leavestat: [],
      wffiltertypeid: 1,
      wfsubfiltertypeid: 1,
      wfsubfilterids: [],
      workforce: [],
      attendancepercentage: null,
      workduration: null,
      overtime: null,
      lateby: null,
      stattypeid: 1,
      atfiltertypeid: 1,
      atsubfiltertypeid: 1,
      atsubfilterids: null,
      attendance: [],
      highest: null,
      lowest: null,
      median: null,
      fromdate: "",
      todate: "",
      overtimes: [],
      punctuality: [],
      address: [],
      absents: [],
      labels: ["Present", "On leave", "Absent"],
    };

    this.selectFilter = this.selectFilter.bind(this);
  }

  componentDidMount() {
    this.getLeaveStat();
    this.getLeaveDistribution();
    this.getWorkForce();
    this.getAttendanceStat();
    this.getOverTime();
    this.getPunctuality();
    this.getMostAbsents();
  }

  getLeaveStat() {
    instance
      .post("trackdashboard/leavestat", {
        filtertypeid: this.state.ldfiltertypeid,
        subfiltertypeid: this.state.ldsubfiltertypeid,
      })
      .then((result) => {
        const data = [];
        const leavedistribution = result.data.result[0]
          ? result.data.result[0].leavestat
          : [];

        result.data.result[0] &&
          result.data.result[0].companyleavestat &&
          data.push(
            result.data.result[0].companyleavestat,
            ...leavedistribution.map((x) => ({
              ...x,
              displayname: x.displayname.substring(0, 12),
            })),
          );

        this.setState({
          leavestat: data,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getLeaveDistribution() {
    instance
      .post("trackdashboard/leavedistribution", {
        filtertypeid: this.state.ldfiltertypeid,
        subfiltertypeid: this.state.ldsubfiltertypeid,
      })
      .then((result) => {
        const leavedistribution = result.data.result[0]
          ? result.data.result[0].leavedistribution
          : [];
        this.setState({
          leavedistribution,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getWorkForce() {
    instance
      .post("trackdashboard/workforce", {
        filtertypeid: this.state.wffiltertypeid,
        subfiltertypeid: this.state.wfsubfiltertypeid,
        subfilterids:
          this.state.wfsubfilterids && this.state.wfsubfilterids.length > 0
            ? this.state.wfsubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const workforce = result.data.result[0]
          ? result.data.result[0].workforcegrapf.map((x) => ({
              x: x.shiftdate,
              y:
                x.presentcount + x.absentcount + x.leavecount == 0
                  ? 0
                  : parseInt(
                      (x.presentcount /
                        (x.presentcount + x.absentcount + x.leavecount)) *
                        100,
                    ),
            }))
          : [];
        const data = [
          {
            id: "Attendance",
            data: workforce,
          },
        ];
        const workdurationobj =
          result.data.result[0] &&
          result.data.result[0].workforce &&
          result.data.result[0].workforce.find(
            (x) => x.displayname == "Work Duration",
          );
        const workduration = workdurationobj
          ? `${parseInt(workdurationobj.median / 60)} hrs ${parseInt(
              workdurationobj.median % 60,
            )} mins`
          : "";
        const overtimeobj =
          result.data.result[0] &&
          result.data.result[0].workforce &&
          result.data.result[0].workforce.find(
            (x) => x.displayname == "Over Time",
          );
        const overtime = overtimeobj
          ? `${parseInt(overtimeobj.median / 60)} hrs ${parseInt(
              overtimeobj.median % 60,
            )} mins`
          : "";
        const latebyobj =
          result.data.result[0] &&
          result.data.result[0].workforce &&
          result.data.result[0].workforce.find(
            (x) => x.displayname == "Late By",
          );
        const lateby = latebyobj
          ? `${parseInt(latebyobj.median / 60)} hrs ${parseInt(
              latebyobj.median % 60,
            )} mins`
          : "";
        this.setState({
          workforce: data,
          attendancepercentage:
            workforce.length > 0
              ? parseInt(
                  workforce
                    .map((x) => x.y)
                    .reduce((prev, curr) => prev + curr) / workforce.length,
                )
              : "",
          workduration,
          overtime,
          lateby,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getAttendanceStat() {
    instance
      .post("trackdashboard/attstat", {
        stattypeid: this.state.stattypeid,
        filtertypeid: this.state.atfiltertypeid,
        subfiltertypeid: this.state.atsubfiltertypeid,
        subfilterids:
          this.state.atsubfilterids && this.state.atsubfilterids.length > 0
            ? this.state.atsubfilterids.join(",")
            : null,
      })
      .then((result) => {
        const attendance = result.data.result[0]
          ? result.data.result[0].attstatgraph.map((x) => ({
              day: x.displayname,
              value: parseFloat(
                parseInt(x.median / 60) +
                  parseFloat(parseFloat((x.median % 60) / 100).toFixed(2)),
              ).toFixed(2),
            }))
          : [];
        const medianobj =
          result.data.result[0] &&
          result.data.result[0].attstat &&
          result.data.result[0].attstat.find((x) => x.displayname == "Median");
        const median = medianobj
          ? `${parseInt(medianobj.median / 60)} hrs ${parseInt(
              medianobj.median % 60,
            )} mins`
          : "";
        const lowobj =
          result.data.result[0] &&
          result.data.result[0].attstat &&
          result.data.result[0].attstat.find((x) => x.displayname == "Lowest");
        const lowest = lowobj
          ? `${parseInt(lowobj.median / 60)} hrs ${parseInt(
              lowobj.median % 60,
            )} mins`
          : "";
        const highobj =
          result.data.result[0] &&
          result.data.result[0].attstat &&
          result.data.result[0].attstat.find((x) => x.displayname == "Higest");
        const highest = highobj
          ? `${parseInt(highobj.median / 60)} hrs ${parseInt(
              highobj.median % 60,
            )} mins`
          : "";
        this.setState({
          attendance,
          median,
          lowest,
          highest,
          fromdate: result.data.result[0]
            ? result.data.result[0].fromdate
            : null,
          todate: result.data.result[0] ? result.data.result[0].todate : null,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  selectFilter(val, key) {
    this.setState(
      {
        [key]: val,
      },
      () => {
        if (key == "ldfiltertypeid" || key == "ldsubfiltertypeid") {
          this.getLeaveStat();
          this.getLeaveDistribution();
        } else if (
          key == "wffiltertypeid" ||
          key == "wfsubfilterids" ||
          (key == "wfsubfiltertypeid" && val == 1)
        ) {
          this.getWorkForce();
        } else if (
          key == "stattypeid" ||
          key == "atfiltertypeid" ||
          key == "atsubfilterids" ||
          (key == "atsubfiltertypeid" && val == 1)
        ) {
          this.getAttendanceStat();
        }
      },
    );
  }

  getPunctuality() {
    instance
      .post("trackdashboard/employeepunctuality")
      .then((result) => {
        const punctuality = [
          ...(result.data.result[0].latecoming &&
            result.data.result[0].latecoming.map((data) => ({
              ...data,
              latecoming: true,
            }))),
          ...(result.data.result[0].earlygoing &&
            result.data.result[0].earlygoing.map((data) => ({
              ...data,
              latecoming: false,
            }))),
        ];
        this.setState({
          punctuality,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getOverTime() {
    instance
      .post("trackdashboard/overtimeemployee")
      .then((result) => {
        this.setState({
          overtimes: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getMostAbsents() {
    instance
      .post("trackdashboard/mostabsentemployee")
      .then((result) => {
        this.setState({
          absents: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  render() {
    const {
      ldfiltertypeid,
      ldsubfiltertypeid,
      wffiltertypeid,
      wfsubfilterids,
      wfsubfiltertypeid,
      atfiltertypeid,
      atsubfilterids,
      atsubfiltertypeid,
      stattypeid,
    } = this.state;
    return (
      <Grid container spacing={1}>
        <Grid item xs={12} md={12} sm={12}>
          <Paper className="padding16 margin-bottom-16">
            <Grid container spacing={1}>
              <Grid item xs={12} md={9} sm={12}>
                <div style={{ display: "flex" }}>
                  <div className="width30 t-bold margin-bottom-8">
                    Leave stats
                  </div>
                  <div className="width30 margin-right-8">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: ldfiltertypeid,
                        label: "",
                        options: filterTypes,
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "ldfiltertypeid")
                      }
                    />
                  </div>
                  <div className="width30">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: ldsubfiltertypeid,
                        label: "",
                        options: subfilterTypes.filter(
                          (x) => x.displayvalue != 1,
                        ),
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "ldsubfiltertypeid")
                      }
                    />
                  </div>
                </div>
                <div className="t-bold" style={{ opacity: "0.7" }}>
                  Leaves taken
                </div>
                <div
                  className="margin-bottom-8"
                  style={{ opacity: "0.7", fontSize: 10 }}
                >
                  Median value per employee
                </div>
                <div style={{ height: 300 }}>
                  <ResponsiveBarCanvas
                    layout="vertical"
                    data={this.state.leavestat}
                    keys={["median"]}
                    indexBy={"displayname"}
                    pixelRatio={1}
                    padding={0.8}
                    margin={{
                      top: 10,
                      right: 10,
                      bottom: 83,
                      left: 30,
                    }}
                    minValue="0"
                    maxValue={Math.max(
                      ...this.state.leavestat.map((x) => x.median),
                    )}
                    colors={(node) => {
                      if (node.data.displayid) {
                        return "#2d99ff";
                      } else {
                        return "#faa500";
                      }
                    }}
                    enableLabel={true}
                    axisRight={null}
                    axisLeft={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: 0,
                      legend: "",
                      legendPosition: "middle",
                      legendOffset: -120,
                    }}
                    axisBottom={{
                      tickSize: 5,
                      tickPadding: 5,
                      tickRotation: -90,
                      legend: "",
                      legendPosition: "middle",
                      legendOffset: -90,
                      tickValues:
                        Math.max(...this.state.leavestat.map((x) => x.median)) >
                        2
                          ? 4
                          : 2,
                    }}
                    enableGridX={true}
                    enableGridY={true}
                    animate={true}
                    motionStiffness={90}
                    motionDamping={15}
                    isInteractive={true}
                  />
                </div>
              </Grid>
              <Grid item xs={12} md={3} sm={12}>
                <div
                  className="t-bold margin-bottom-8"
                  style={{ opacity: "0.7" }}
                >
                  Leave-type distribution %
                </div>
                <div className="doughnut-chart">
                  {
                    <Doughnut
                      data={{
                        labels: this.state.leavedistribution.map(
                          (x) => x.displayname,
                        ),
                        datasets: [
                          {
                            label: "Leave-type distribution %",
                            data: this.state.leavedistribution.map(
                              (x) => x.displayvalue,
                            ),
                            backgroundColor: [
                              "#2cd9c5",
                              "#f86b07",
                              "#d02dff",
                              "#826af9",
                              "#96f7df",
                              "#f7dc96",
                              "#d0f796",
                              "#e0f7fa",
                              "#eceff1",
                              "#efebe9",
                              "#d7ccc8",
                              "#cfd8dc",
                              "#e3f2fd",
                              "#fff9c4",
                              "#b2dfdb",
                              "#c8e6c9",
                              "#e0e0e0",
                              "#ffe0b2",
                              "#f3e5f5",
                            ],
                          },
                        ],
                      }}
                      width="150px"
                      height="100px"
                      options={{
                        rotation: 100,
                        animation: {
                          animateRotate: true,
                        },
                        tooltips: {
                          footerFontSize: 18,
                          titleFontSize: 18,
                          bodyFontSize: 18,
                        },
                        legend: {
                          display: true,
                          position: "right",
                          fullWidth: false,
                          labels: {
                            fontSize: 16,
                          },
                        },
                      }}
                    />
                  }
                </div>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={12} sm={12} md={12}>
          <Paper className="padding16 margin-bottom-16">
            <Grid container spacing={1}>
              <Grid item xs={12} md={2} sm={12}>
                <div className="t-bold margin-bottom-8">
                  Workforce availability
                </div>
                <div
                  className="margin-bottom-8"
                  style={{ opacity: "0.7", fontSize: 10 }}
                >
                  Median value per employee
                </div>
              </Grid>
              <Grid item xs={12} md={10} sm={12}>
                <div
                  className="width100"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div className="width30 margin-right-8">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: wffiltertypeid,
                        label: "",
                        options: [
                          ...requestCountTypes.filter(
                            (x) => x.displayvalue != 6,
                          ),
                          ...filterTypes.filter(
                            (x) => x.displayvalue == 1 || x.displayvalue == 2,
                          ),
                        ],
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "wffiltertypeid")
                      }
                    />
                  </div>
                  <div className="margin-right-8 width30">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: wfsubfiltertypeid,
                        label: "",
                        options: subfilterTypes,
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "wfsubfiltertypeid")
                      }
                    />
                  </div>
                  {wfsubfiltertypeid && wfsubfiltertypeid != 1 && (
                    <div className="width30">
                      <DynamicForm
                        fields={multiselectinputconverter({
                          value: wfsubfilterids,
                          label: "",
                          options:
                            wfsubfiltertypeid == 2
                              ? this.props.businessUnits
                              : wfsubfiltertypeid == 3
                              ? this.props.departmentList
                              : wfsubfiltertypeid == 4
                              ? this.props.locationList
                              : [],
                          disabled: false,
                          idonly: true,
                        })}
                        onChange={(val) =>
                          this.selectFilter(val, "wfsubfilterids")
                        }
                      />
                    </div>
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} sm={12}>
                <div
                  className="width100"
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    textAlign: "center",
                  }}
                >
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Attendance
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.attendancepercentage}%
                    </div>
                  </div>
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Work duration
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.workduration}
                    </div>
                  </div>
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Overtime
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.overtime}
                    </div>
                  </div>
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Late duration
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.lateby}
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
            <div style={{ height: 300 }} className="line-data">
              <ResponsiveLineCanvas
                height={300}
                enablePointLabel={false}
                pointLabel="y"
                pointLabelYOffset={-12}
                useMesh={true}
                enableGridX={true}
                colors={["#d02dff"]}
                lineWidth={1}
                pointSize={4}
                data={this.state.workforce}
                margin={{
                  top: 20,
                  right: 80,
                  bottom: 26,
                  left: 55,
                }}
                axisLeft={{
                  orient: "left",
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  legend: "Attendace percentage",
                  legendOffset: -46,
                  legendPosition: "middle",
                  tickValues: [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
                }}
                enableLabel={true}
                enableGridY={true}
                animate={true}
                motionStiffness={90}
                motionDamping={15}
                isInteractive={true}
                xScale={{
                  type: "time",
                  format: "%Y-%m-%d",
                  precision: "day",
                }}
                xFormat="time:%Y-%m-%d"
                axisBottom={{
                  orient: "bottom",
                  tickSize: 5,
                  tickPadding: 5,
                  tickRotation: 0,
                  format: "%b %d",
                  legend: "",
                  legendOffset: 23,
                  legendPosition: "middle",
                  tickValues: "every 1 week",
                }}
              />
            </div>
          </Paper>
          <Paper className="padding16 margin-bottom-16">
            <Grid container spacing={1}>
              <Grid item xs={12} md={2} sm={12}>
                <div className="t-bold margin-bottom-8">Attendance stats</div>
              </Grid>
              <Grid item xs={12} md={10} sm={12}>
                <div
                  className="width100"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div className="margin-right-8 width30">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: stattypeid,
                        label: "",
                        options: attendanceStateTypes,
                        disabled: false,
                      })}
                      onChange={(val) => this.selectFilter(val, "stattypeid")}
                    />
                  </div>
                  <div className="width30 margin-right-8">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: atfiltertypeid,
                        label: "",
                        options: [
                          ...requestCountTypes.filter(
                            (x) => x.displayvalue != 6,
                          ),
                          ...filterTypes.filter((x) => x.displayvalue != 5),
                        ],
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "atfiltertypeid")
                      }
                    />
                  </div>
                  <div className="margin-right-8 width30">
                    <DynamicForm
                      fields={selectinputconverter({
                        value: atsubfiltertypeid,
                        label: "",
                        options: subfilterTypes,
                        disabled: false,
                      })}
                      onChange={(val) =>
                        this.selectFilter(val, "atsubfiltertypeid")
                      }
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
            <Grid container spacing={1}>
              <Grid item xs={12} md={12} sm={12}>
                <div
                  className="width100"
                  style={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Highest
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.highest}
                    </div>
                  </div>
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Lowest
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.lowest}
                    </div>
                  </div>
                  <div className="width25">
                    <div
                      className="t-bold"
                      style={{ opacity: "0.7", fontSize: 10 }}
                    >
                      Median
                    </div>
                    <div className="t-bold" style={{ color: "#057cff" }}>
                      {this.state.median}
                    </div>
                  </div>
                  <div className="width25">
                    {atsubfiltertypeid && atsubfiltertypeid != 1 && (
                      <div className="width100">
                        <DynamicForm
                          fields={multiselectinputconverter({
                            value: atsubfilterids,
                            label: "",
                            options:
                              atsubfiltertypeid == 2
                                ? this.props.businessUnits
                                : atsubfiltertypeid == 3
                                ? this.props.departmentList
                                : atsubfiltertypeid == 4
                                ? this.props.locationList
                                : [],
                            disabled: false,
                            idonly: true,
                          })}
                          onChange={(val) =>
                            this.selectFilter(val, "atsubfilterids")
                          }
                        />
                      </div>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
            <div style={{ height: 250 }} className="line-data">
              <ResponsiveCalendarCanvas
                height={250}
                data={this.state.attendance}
                from={this.state.fromdate}
                to={this.state.todate}
                emptyColor="#eeeeee"
                colors={[
                  "#d8d8d8",
                  "#2cd9c5",
                  "#97e3d6",
                  "#ffe700",
                  "#f86b07",
                  "#ff4052",
                ]}
                minValue={0}
                maxValue={"auto"}
                margin={{ top: 10, right: 10, bottom: 10, left: 20 }}
                yearSpacing={0}
                monthBorderWidth={0}
                monthBorderColor="#ffffff"
                dayBorderWidth={2}
                dayBorderColor="#ffffff"
                legends={[
                  {
                    anchor: "bottom-right",
                    direction: "row",
                    translateY: -16,
                    itemCount: 5,
                    itemWidth: 42,
                    itemHeight: 26,
                    itemsSpacing: 14,
                    itemDirection: "right-to-left",
                  },
                ]}
              />
            </div>
            <div className="abcd">
              <Grid container>
                {/* {this.state.punctuality.length > 0 && ( */}
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={12}
                  style={{ padding: "0px 12px 0px 24px" }}
                >
                  <div className="margin-bottom-24">
                    <LabelIcon
                      label="Today’s punctuality problems"
                      img={Clock}
                    />
                    <Paper
                      className="padding16 thin-scroll"
                      style={{
                        height: 200,
                        overflowY: "auto",
                        position: "relative",
                      }}
                    >
                      {this.state.punctuality.length > 0 ? (
                        this.state.punctuality.map((data) => (
                          <div style={{ padding: "8px 16px" }}>
                            <Grid
                              container
                              style={{
                                borderBottom: "1px solid #edf5fd",
                                paddingBottom: 4,
                              }}
                            >
                              <Grid item xs={12} md={1} sm={12}>
                                <p className="t-12 margin-top-2">
                                  {data.latecoming && "⏰"}
                                  {!data.latecoming && "🏃‍♂️"}
                                </p>
                              </Grid>
                              <Grid item xs={12} md={7} sm={12}>
                                <p className="small-dark-secondary">
                                  {data.fullname}
                                </p>
                                <p className="extra-small-dark-disabled">
                                  {data.designationname}
                                </p>
                              </Grid>
                              <Grid item xs={12} md={4} sm={12}>
                                <p className="small-dark-secondary text-align-right">
                                  {data.latecoming && "Late"}
                                  {!data.latecoming && "Left early"}
                                </p>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      ) : (
                        <div className="text-align-center margin-top-30">
                          No records found
                        </div>
                      )}
                    </Paper>
                  </div>
                </Grid>
                {/* )} */}
                {/* {this.state.overtimes.length > 0 && ( */}
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={12}
                  style={{ padding: "0px 12px 0px 12px" }}
                >
                  <div className="margin-bottom-24">
                    <LabelIcon label="Overtimers this week" img={Clock} />
                    <Paper
                      className="padding16 thin-scroll"
                      style={{
                        overflowY: "auto",
                        height: 200,
                      }}
                    >
                      {this.state.overtimes.length > 0 ? (
                        this.state.overtimes.map((overtime) => (
                          <div style={{ padding: "8px 16px" }}>
                            <Grid
                              container
                              style={{
                                borderBottom: "1px solid #edf5fd",
                                paddingBottom: 4,
                              }}
                            >
                              <Grid item xs={12} md={1} sm={12}>
                                <p className="t-12 margin-top-2">🔥</p>
                              </Grid>
                              <Grid item xs={12} md={11} sm={12}>
                                <p className="small-dark-secondary">
                                  {overtime.fullname}
                                </p>
                                <p className="extra-small-dark-disabled">
                                  {overtime.designationname}
                                </p>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      ) : (
                        <div className="text-align-center margin-top-30">
                          No records found
                        </div>
                      )}
                    </Paper>
                  </div>
                </Grid>
                {/* )} */}
                {/* {this.state.absents.length > 0 && ( */}
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={12}
                  style={{ padding: "0px 12px 0px 12px" }}
                >
                  <div className="margin-bottom-24">
                    <LabelIcon
                      label="Most absent last week"
                      labelClassNames="small-dark-secondary"
                      img={Search}
                    />
                    <Paper
                      className="padding16 thin-scroll"
                      style={{
                        overflowY: "auto",
                        height: 200,
                      }}
                    >
                      {this.state.absents.length > 0 ? (
                        this.state.absents.map((emp) => (
                          <div style={{ padding: "8px 0px" }}>
                            <Grid
                              container
                              style={{
                                borderBottom: "1px solid #edf5fd",
                                paddingBottom: 4,
                              }}
                            >
                              <Grid item xs={12} md={1} sm={12}>
                                <p className="t-12 margin-top-2">🔍</p>
                              </Grid>
                              <Grid item xs={12} md={7} sm={12}>
                                <p className="small-dark-secondary">
                                  {emp.fullname}
                                </p>
                                <p className="extra-small-dark-disabled">
                                  {emp.designationname}
                                </p>
                              </Grid>
                              <Grid item xs={12} md={4} sm={12}>
                                <p className="small-dark-secondary text-align-right">
                                  {emp.totalabsentcount} Absences
                                </p>
                              </Grid>
                            </Grid>
                          </div>
                        ))
                      ) : (
                        <div className="text-align-center margin-top-30">
                          No records found
                        </div>
                      )}
                    </Paper>
                  </div>
                </Grid>
                {/* )} */}
              </Grid>
            </div>
          </Paper>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} md={4} sm={12}>
            <ShareIdea openForm={this.props.openForm} />
          </Grid>
        </Grid>
      </Grid>
    );
  }
}

export default Employeetracking;
